import { Component, ElementRef, Inject, OnInit, SimpleChanges } from '@angular/core';
import { NbStepChangeEvent } from '@nebular/theme';
import { HeaderEditorStoreService } from './../../header-editor-store.service';
import { HeaderConfig } from '@urbannex/storethemes';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';

@Component({
  selector: 'ngx-logo-navigation',
  templateUrl: './logo-navigation.component.html',
  styleUrls: ['./logo-navigation.component.scss']
})
export class LogoNavigationComponent implements OnInit {
  sectionId:string;

  siteName:String;

  showStoreName:boolean;

  fileName = "";

  form: FormGroup;

  handleStepChange(e: NbStepChangeEvent): void {
    
  }
  constructor(private el:ElementRef,
    private previewEditStore:HeaderEditorStoreService,
    private headerEditorStore:HeaderEditorStoreService,
    private ofbizFormsService:OfbizFormsService,
    private fb:FormBuilder
    ) { }

  ngOnInit(): void {
    let host = <HTMLElement>this.el.nativeElement;
    host.style.setProperty('--tabset-content-padding','0.875rem 1rem');

    this.form = this.fb.group({
      contentId:[''],
      uploadedFile:[null]
    })

    this.previewEditStore.headerConfigState$.subscribe((headerConfig:HeaderConfig) => {
      this.siteName = headerConfig.mainHeaderConfig.logoNavConfig.storeName;
      this.showStoreName = headerConfig.mainHeaderConfig.logoNavConfig.showStoreName;
      this.sectionId = headerConfig.sectionId;
      if(this.sectionId != undefined){
        this.form.controls["contentId"].patchValue(this.sectionId);
      }
    })
    

    
  }

  onFileSelected(e){
    console.log(e);
    const file:File = e.target.files[0];

    if (file) {

      this.fileName = file.name;

      const formData = new FormData();

      formData.append("uploadedFile", file);
      formData.append("contentId",this.sectionId);
      setTimeout(() => {
        this.ofbizFormsService.postFormData(formData,"kwikstore","uploadLogo",true)
      .subscribe()
      }, 100);
      
    }

  }

  onChangeSiteName(e){
    this.headerEditorStore.updateSiteName(e);
    console.log(e)
  }

  onChangeShowStoreName(e){
   this.headerEditorStore.updateShowStoreName(e);
    //this.headerEditorStore.updateShowStoreName(e)
  }

  uploadFile(e){
    console.log(e);

    if (e.target.files.length > 0) {
      let file = (e.target as HTMLInputElement).files[0];
      console.log(file);
      this.fileName = file.name;
      //this.createPreview(file);
      file = new File([file], file.name);
      //this.form.controls['uploadedFile'].patchValue(file);
      //this.form.get('uploadedFile').patchValue(file);
      //this.form.controls["contentId"].setValue(this.sectionId);
      
      let formData = new FormData();
      formData.append("contentId",this.sectionId);
      formData.append("uploadedFile",this.form.controls["uploadedFile"].value);
      //formData.append("file",file);
      console.log(JSON.stringify(this.form.value));
        this.ofbizFormsService.postFormData(formData,"kwikstore","uploadLogo",true)
      .subscribe()

      
    }

/* 
    this.form.controls["contentId"].setValue(this.sectionId);
    let formData = new FormData();
    formData.append("contentId",this.sectionId);
    formData.append("uploadedFile",this.form.get("uploadedFile").value);
    console.log(JSON.stringify(this.form.value));

    this.ofbizFormsService.postFormData(formData,"kwikstore","uploadLogo",true)
    .subscribe() */
  }

}
